module.exports = __webpack_public_path__ + "img/as1.f2fce5de.jpeg";